document.addEventListener('DOMContentLoaded', function() {
    lazyload();
});



// WEBPACK FOOTER //
// ./resources/assets/public-website/js/lazyload.js